(() => {
  const destination = '/pages/get-a-quote#ci3d-project-quote';

  function normalizeProjectQuoteLinks(root = document) {
    if (document.getElementById('ci3d-project-quote')) return;

    root.querySelectorAll?.('a[href="#ci3d-project-quote"]').forEach((link) => {
      link.href = destination;
    });
  }

  const run = () => normalizeProjectQuoteLinks(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('load', run, { once: true });
  window.setTimeout(run, 800);
  window.setTimeout(run, 1800);

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => {
    normalizeProjectQuoteLinks(event.target);
  });
})();
